import { FC } from "react"
import { Lead } from "../../../../../../../types"
import SectionCell from "../../../../../section/cell"

interface Props {
  data: Lead
  cols: number
}

const PropertyLocation: FC<Props> = ({ data, cols }) => {
  const {
    details: {
      location: { state, city, street, county, zipcode }
    }
  } = data
  return (
    <div className={`grid grid-cols-${cols} gap-4`}>
      <SectionCell label="Street address" value={street} />
      <SectionCell label="City" value={city} />
      <SectionCell label="State" value={state} />
      <SectionCell label="County" value={county} />
      <SectionCell label="Zipcode" value={zipcode} />
    </div>
  )
}

export default PropertyLocation
